import { useEffect, useState } from "react";
import { Cpu, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Popup componente per il cliente finale: foto grande e spiegazione semplice
export function ClienteComponente({ c, src, onClose }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    if (c) src.componente(c.codice).then(setD).catch(() => setD({ spiegazione: c.descrizione }));
  }, [c]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={!!c} onOpenChange={(o) => !o && onClose()}>
      {c && (
        <DialogContent className="cliente-font max-w-md rounded-3xl bg-white text-slate-800" data-testid="cliente-comp-dialog">
          <DialogHeader>
            <DialogTitle className="text-lg font-extrabold" data-testid="cliente-comp-titolo">{c.codice}</DialogTitle>
            <DialogDescription className="text-xs font-bold uppercase tracking-wider text-slate-400">{c.tipo}{c.quantita ? ` × ${c.quantita}` : ""}</DialogDescription>
          </DialogHeader>
          <div className="flex h-56 items-center justify-center overflow-hidden rounded-2xl bg-slate-50">
            {c.foto ? <img src={encodeURI(decodeURI(c.foto))} alt={c.codice} className="h-full w-full object-contain p-3" /> : <Cpu className="h-10 w-10 text-slate-300" />}
          </div>
          {!d ? <p className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Vesta prepara la spiegazione…</p>
            : <p className="text-sm leading-relaxed text-slate-600" data-testid="cliente-comp-spiegazione">{d.spiegazione || "Componente originale TORRI, scelto dal tuo installatore per il tuo impianto."}</p>}
          {d?.scheda_sito_url && <a href={d.scheda_sito_url} target="_blank" rel="noreferrer" className="text-sm font-bold text-sky-700 hover:underline" data-testid="cliente-comp-link">Scopri di più su torri.solar →</a>}
        </DialogContent>
      )}
    </Dialog>
  );
}
